import { useEffect, useState } from 'react';

function resolve(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'dark';
  // The manual override (html[data-theme], lib/theme.ts) wins over the OS.
  const forced = document.documentElement.getAttribute('data-theme');
  if (forced === 'light' || forced === 'dark') return forced;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

/**
 * Reactive light/dark reader. The chart layer needs the resolved mode in JS
 * (ECharts colors aren't CSS), and it must re-theme if the OS flips or the
 * user picks light/dark in Settings while the app is open.
 */
export function useThemeMode(): 'light' | 'dark' {
  const [mode, setMode] = useState<'light' | 'dark'>(resolve);

  useEffect(() => {
    const update = (): void => setMode(resolve());
    const mq = window.matchMedia('(prefers-color-scheme: light)');
    mq.addEventListener('change', update);
    const mo = new MutationObserver(update);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => {
      mq.removeEventListener('change', update);
      mo.disconnect();
    };
  }, []);

  return mode;
}
